module.exports = __webpack_public_path__ + "img/Vocabulary_8.75cc4c9d.svg";